import { render, staticRenderFns } from "./TeamHomeOne.vue?vue&type=template&id=f6f144ea"
import script from "./TeamHomeOne.vue?vue&type=script&lang=js"
export * from "./TeamHomeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports